__turbopack_context__.v({
  "container": "EventLikedToast-module-scss-module__KMRwnq__container",
  "link": "EventLikedToast-module-scss-module__KMRwnq__link",
  "message": "EventLikedToast-module-scss-module__KMRwnq__message",
});
